<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">diagnosis</span>
      <p>
        Registra los diagnósticos de la atención con su código CIE-10,
        clasificándolos como presuntivos o definitivos. Es obligatorio tener
        al menos un diagnóstico para poder finalizar la atención.
      </p>
    </div>

    <!-- Cómo funciona -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Cómo funciona
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in flujo" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Buscador de diagnósticos -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">search</span>
        Buscador de diagnósticos (CIE-10)
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in buscador" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Tipos de diagnóstico -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">category</span>
        Tipos de diagnóstico
      </h3>
      <div class="help-estados" style="margin-bottom:0.5rem">
        <span class="help-estado-badge" style="background:#fff3cd;color:#856404">Presuntivo</span>
        <span class="help-estado-badge" style="background:#d4edda;color:#155724">Definitivo</span>
      </div>
      <div class="help-cards" style="margin-top:0.5rem">
        <div class="help-card">
          <span class="material-symbols-outlined help-card-icon">help_outline</span>
          <div>
            <p class="help-card-title">Presuntivo (P)</p>
            <p class="help-card-desc">Diagnóstico probable basado en los síntomas y el examen clínico inicial. Puede confirmarse o descartarse con estudios complementarios.</p>
          </div>
        </div>
        <div class="help-card">
          <span class="material-symbols-outlined help-card-icon">verified</span>
          <div>
            <p class="help-card-title">Definitivo (D)</p>
            <p class="help-card-desc">Diagnóstico confirmado tras la evaluación clínica completa, exámenes o evolución del paciente.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Acciones -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Acciones disponibles
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Restricción por estado -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">lock</span>
        Restricciones por estado de la atención
      </h3>
      <div class="help-estados" style="margin-bottom:0.5rem">
        <span class="help-estado-badge" style="background:#fff3cd;color:#856404">PENDIENTE</span>
        <span class="help-estado-badge" style="background:#cce5ff;color:#004085">PROCESO</span>
      </div>
      <p class="help-card-desc" style="padding:0 0.25rem">
        Agregar, editar y eliminar diagnósticos solo está habilitado cuando
        la atención está en estado <strong>PENDIENTE</strong> o
        <strong>PROCESO</strong>. En cualquier otro estado los botones
        no se muestran.
      </p>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Es obligatorio registrar al menos un diagnóstico para poder
        <strong>Finalizar</strong> la atención. Si intentas finalizar sin
        diagnósticos, el sistema mostrará un error indicando que se requiere
        al menos uno.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaDiagAten",
  data() {
    return {
      flujo: [
        {
          icon: "add_circle",
          titulo: "Nuevo diagnóstico",
          desc:   "Pulsa el botón Nueva para abrir el formulario. Busca el diagnóstico por nombre o código CIE-10, selecciónalo y elige el tipo (Presuntivo o Definitivo).",
        },
        {
          icon: "table_rows",
          titulo: "Lista de diagnósticos",
          desc:   "La tabla muestra todos los diagnósticos registrados para la atención con su código CIE-10, nombre y tipo. El nombre también incluye el estado del diagnóstico.",
        },
        {
          icon: "edit",
          titulo: "Editar un diagnóstico",
          desc:   "Pulsa el ícono de edición para modificar el diagnóstico seleccionado o cambiar su tipo de Presuntivo a Definitivo.",
        },
      ],
      buscador: [
        {
          icon: "text_fields",
          titulo: "Búsqueda por texto",
          desc:   "Escribe parte del nombre o código del diagnóstico en el campo de búsqueda. La lista se filtra en tiempo real mostrando las coincidencias.",
        },
        {
          icon: "keyboard_return",
          titulo: "Abrir con Enter",
          desc:   "Presiona Enter en el campo de búsqueda para desplegar el listado filtrado sin necesidad de hacer clic en el botón.",
        },
        {
          icon: "touch_app",
          titulo: "Seleccionar",
          desc:   "Haz clic en el diagnóstico deseado de la lista desplegable para asignarlo al registro. El campo muestra automáticamente el código y nombre seleccionados.",
        },
      ],
      acciones: [
        {
          icon:   "add_circle",
          color:  "#0059cc",
          titulo: "Nuevo",
          desc:   "Abre el formulario para registrar un nuevo diagnóstico. Requiere seleccionar un diagnóstico del catálogo CIE-10 y definir su tipo. Solo disponible en atenciones PENDIENTE o PROCESO.",
        },
        {
          icon:   "edit",
          color:  "#198754",
          titulo: "Editar",
          desc:   "Permite modificar el diagnóstico o cambiar su tipo. El campo de búsqueda se precarga con el código y nombre del diagnóstico actual.",
        },
        {
          icon:   "delete",
          color:  "#dc3545",
          titulo: "Eliminar",
          desc:   "Elimina el diagnóstico de la atención de forma permanente. Solo disponible en atenciones PENDIENTE o PROCESO.",
        },
        {
          icon:   "refresh",
          color:  "#6c757d",
          titulo: "Recargar",
          desc:   "Recarga la lista de diagnósticos registrados para la atención actual.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>